import script from "./ExpertisesView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExpertisesView.vue?vue&type=script&setup=true&lang=ts"

import "./ExpertisesView.vue?vue&type=style&index=0&id=08e32592&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08e32592"]])

export default __exports__